import React, { useCallback, useState } from "react";

import { withTranslation } from "hoc/WithTranslation";
import { CustomModal } from "components/base";
import { useWindowWidth } from "hooks";
import m from "definedMessages";


const ModalCancelPaymentRequest = ({
    show,
    onClose,
    maxWidth = 600,
    selectedRequest,
    rejectPaymentRequest,
    getPaymentRequestList,
    onSuccess,
    updateAccount,

    formatMessage
}) => {

    const resizedWidth = useWindowWidth();
    const [loading, setLoading] = useState(false);

    const handleSuccess = useCallback(async () => {
        if (!selectedRequest?.id) {
            return;
        }

        setLoading(true);

        const data = {
            target: {
                payment_request_id: selectedRequest.id,
            },
        };

        try {
            const response = await rejectPaymentRequest(data, true);

            if (response?.payment_request) {
                getPaymentRequestList();
                onSuccess(selectedRequest?.amount || 0);
                updateAccount();
            }
        } finally {
            setLoading(false);
            onClose();
        }
    }, [
        getPaymentRequestList,
        onClose,
        onSuccess,
        rejectPaymentRequest,
        selectedRequest,
        updateAccount,
    ]);

    return (
        <CustomModal
            show={show}
            onClose={() => onClose(false)}
            title={formatMessage(m.cancelPaymentRequest)}
            width={resizedWidth > maxWidth ? maxWidth : resizedWidth}
            showFooter={true}
            loading={loading}
            confirmButtonText={formatMessage(m.yes)}
            focusTarget="close"
            onConfirm={handleSuccess}
        >
            {formatMessage(m.areYouSure)}
        </CustomModal>
    );
};

export default withTranslation(ModalCancelPaymentRequest);
